import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getWorkshop = 'workshop-pelatihan';
const getWebinar = 'workshop-pelatihan-webinar';
const getDataOffline = 'workshop-pelatihan';
const getDetailWorkshop = 'workshop-pelatihan/';
const postWorkshopUrl = 'workshop-pelatihan';
const putWorkshopUrl = 'workshop-pelatihan/';
const putKuesioner = 'kusioner/';
const deleteWorkshop = 'workshop-pelatihan/';
const getKatalog = 'katalog-pelatihan';

class WorkshopService {

    getDetailPengaturanSertifikat(id) {
        return axios.get(
            API_URL + 'workshop-pelatihan/detail-pengaturan-sertifikat/'+id, {
            headers: authHeader()
        });
    }

    updatePengaturanSertifikat(formData) {
        var form = new FormData();
        if(typeof formData.flyer !== 'undefined' || formData.flyer !== undefined ) {
            form.append("file",formData.flyer); 
        }
        form.append("textLineSatu",formData.textLineSatu); 
        form.append("textLineDua",formData.textLineDua); 
        form.append("textLineTiga",formData.textLineTiga); 
        form.append("textLineEmpat",formData.textLineEmpat); 
        form.append("textLineLima",formData.textLineLima); 
        form.append("textLineEnam",formData.textLineEnam); 
        form.append("textLineTujuh",formData.textLineTujuh); 
        form.append("textLineDelapan",formData.textLineDelapan); 
        form.append("textLineSembilan",formData.textLineSembilan); 
        form.append("tanggalPelatihan",formData.tanggalPelatihan); 
        
        return axios
        .put(
            API_URL + "workshop-pelatihan/pengaturan-sertifikat/"+formData.id_workshop_pelatihan,
            form, 
            { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } }
        );
    }

    getDetailWorkshop(id_workshop_pelatihan) {
        return axios.get(
            API_URL + getDetailWorkshop+id_workshop_pelatihan, {
            headers: authHeader()
        });
    }

    getWorkshop(currentPage, pageSize, filter, tahun = null) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            tahun : tahun
        }

        return axios.get(
            API_URL + getWorkshop, {
            params : data,
            headers: authHeader()
        });
    }

    getWebinar(currentPage, pageSize, filter, tahun = null) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter,
            tahun : tahun
        }

        return axios.get(
            API_URL + getWebinar, {
            params : data,
            headers: authHeader()
        });
    }
    getDataOffline(currentPage, pageSize, filter) {
        var data = {
            pageNo : currentPage,
            pageSize : pageSize,
            filter : filter
        }

        return axios.get(
            API_URL + getDataOffline, {
            params : data,
            headers: authHeader()
        });
    }

    getKatalog() {
        return axios.get(
            API_URL + getKatalog , {
                headers: authHeader()
            });
    }

    postWorkshopUrl(formData) {    
        var form = new FormData();
        
        form.append("idKodePelatihan",formData.idKodePelatihan); 
        form.append("materi",formData.materi); 
        if(typeof formData.flyer !== 'undefined' || formData.flyer !== undefined ) {
            form.append("flyer",formData.flyer); 
        }
        
        form.append("biaya",formData.biaya);
        form.append("disclaimer",formData.disclaimer);
        form.append("durasi",formData.durasi);
        form.append("linkKuesioner",formData.linkKuesioner);
        form.append("keteranganKuesioner",formData.keteranganKuesioner); 
        form.append("tanggalPengumumanSkp",formData.tanggalPengumumanSkp);
        form.append("biayaAnggotaAp",formData.biayaAnggotaAp);
        form.append("biayaAnggotaNonAp",formData.biayaAnggotaNonAp);
        form.append("biayaUmum",formData.biayaUmum);
        form.append("deskripsiPelatihan",formData.deskripsiPelatihan);
        form.append("idInstruktur",formData.idInstruktur);
        form.append("idKotaKab",formData.idKotaKab);
        form.append("idPenyelenggara",formData.idPenyelenggara);
        form.append("idWorkshopPelatihan",formData.idWorkshopPelatihan);
        form.append("idTandaTangan",formData.idTandaTangan);
        form.append("jumlahKursiAP",formData.jumlahKursiAP);
        form.append("jumlahKursiNonAP",formData.jumlahKursiNonAP);
        form.append("jumlahKursiUmum",formData.jumlahKursiUmum);
        form.append("namaPelatihan",formData.namaPelatihan);
        form.append("namaTempatPelatihan",formData.namaTempatPelatihan);
        form.append("noLaporPPL",formData.noLaporPPL);
        form.append("tipePelatihan",formData.tipePelatihan);
        form.append("linkMateri",formData.linkMateri);

        if (typeof formData.backgroundSertifikat !== 'undefined') {
            form.append('backgroundSertifikat', formData.backgroundSertifikat);
        }

        if(formData.linkZoom != 'undefined' || formData.linkZoom != undefined)
        {
            form.append("linkZoom",formData.linkZoom);
        }

        for (let index = 0; index < formData.linkWebinar.length; index++) {
      
            form.append("linkWebinar["+index+"].linkWebinar",formData.linkWebinar[index].linkWebinar);
            form.append("linkWebinar["+index+"].keterangan",formData.linkWebinar[index].keterangan);
        }
        
        for (let index = 0; index < formData.pelatihanMateri.length; index++) {
            if (typeof formData.pelatihanMateri[index].fileMateri !== 'undefined') {
                form.append("pelatihanMateri["+index+"].fileMateri",formData.pelatihanMateri[index].fileMateri);
            }
            form.append("pelatihanMateri["+index+"].namaMateri",formData.pelatihanMateri[index].namaMateri);
        }

        for (let index = 0; index < formData.pelatihanDokumen.length; index++) {
            form.append("pelatihanDokumen["+index+"].idMasterDokumen",formData.pelatihanDokumen[index].idMasterDokumen);
            form.append("pelatihanDokumen["+index+"].statusRequired",formData.pelatihanDokumen[index].statusRequired);
        }

        for (let index = 0; index < formData.pelatihanInstruktur.length; index++) {
            form.append("pelatihanInstruktur["+index+"].idDatInstrukturPelatihan",formData.pelatihanInstruktur[index].idDatInstrukturPelatihan);
            form.append("pelatihanInstruktur["+index+"].idInstrukturPelatihan",formData.pelatihanInstruktur[index].idInstrukturPelatihan);
            form.append("pelatihanInstruktur["+index+"].skpNonTerstruktur",formData.pelatihanInstruktur[index].skpNonTerstruktur);
            form.append("pelatihanInstruktur["+index+"].skpTerstruktur",formData.pelatihanInstruktur[index].skpTerstruktur);

            for (let x = 0; x < formData.pelatihanInstruktur[index].katalogInstruktur.length; x++) {
                form.append("pelatihanInstruktur["+index+"].katalogInstruktur["+x+"].skpTerstrukturKatalog",formData.pelatihanInstruktur[index].katalogInstruktur[x].skpTerstrukturKatalog);
                form.append("pelatihanInstruktur["+index+"].katalogInstruktur["+x+"].skpNonTerstrukturKatalog",formData.pelatihanInstruktur[index].katalogInstruktur[x].skpNonTerstrukturKatalog);
            }
        }

        for (let index = 0; index < formData.pelatihanKatalog.length; index++) {
            form.append("pelatihanKatalog["+index+"].idDatKatalogPelatihan",formData.pelatihanKatalog[index].idDatKatalogPelatihan);
            form.append("pelatihanKatalog["+index+"].idKatalogPelatihan",formData.pelatihanKatalog[index].idKatalogPelatihan);
            form.append("pelatihanKatalog["+index+"].skpNonTerstruktur",formData.pelatihanKatalog[index].skpNonTerstruktur);
            form.append("pelatihanKatalog["+index+"].skpTerstruktur",formData.pelatihanKatalog[index].skpTerstruktur);
        }

        for (let index = 0; index < formData.pelatihanModerator.length; index++) {
            form.append("pelatihanModerator["+index+"].idDatModeratorPelatihan",formData.pelatihanModerator[index].idDatModeratorPelatihan);
            form.append("pelatihanModerator["+index+"].namaModerator",formData.pelatihanModerator[index].namaModerator);
            form.append("pelatihanModerator["+index+"].idModerator",formData.pelatihanModerator[index].idModerator);
            form.append("pelatihanModerator["+index+"].skpNonTerstruktur",formData.pelatihanModerator[index].skpNonTerstruktur);
            form.append("pelatihanModerator["+index+"].skpTerstruktur",formData.pelatihanModerator[index].skpTerstruktur);

            for (let x = 0; x < formData.pelatihanModerator[index].katalogModerator.length; x++) {
                form.append("pelatihanModerator["+index+"].katalogModerator["+x+"].skpTerstrukturKatalog",formData.pelatihanModerator[index].katalogModerator[x].skpTerstrukturKatalog);
                form.append("pelatihanModerator["+index+"].katalogModerator["+x+"].skpNonTerstrukturKatalog",formData.pelatihanModerator[index].katalogModerator[x].skpNonTerstrukturKatalog);
            }
        }

        for (let index = 0; index < formData.jadwalPelatihanRequest.length; index++) {
            form.append("jadwalPelatihanRequest["+index+"].waktuDimulai",formData.jadwalPelatihanRequest[index].waktuDimulai);
            form.append("jadwalPelatihanRequest["+index+"].waktuBerakhir",formData.jadwalPelatihanRequest[index].waktuBerakhir);
            form.append("jadwalPelatihanRequest["+index+"].tanggal",formData.jadwalPelatihanRequest[index].tanggal);
        }

        for (let index = 0; index < formData.pengaturanAssessment.length; index++) {
            
            form.append("pengaturanAssessment["+index+"].rangeSatu",formData.pengaturanAssessment[index].rangeSatu);
            form.append("pengaturanAssessment["+index+"].rangeDua",formData.pengaturanAssessment[index].rangeDua);
            form.append("pengaturanAssessment["+index+"].assessment",formData.pengaturanAssessment[index].assessment);
            
        }
       
        form.append("skpIapiAssesment",formData.skpIapiAssesment);
        form.append("skpIapiNonTerstruktur",formData.skpIapiNonTerstruktur);
        form.append("skpIapiTerstruktur",formData.skpIapiTerstruktur);
        form.append("skpNonIapiNonTerstruktur",formData.skpNonIapiNonTerstruktur);
        form.append("skpNonIapiTerstruktur",formData.skpNonIapiTerstruktur);
        form.append("skpNonIapiAssesment",formData.skpNonIapiAssesment);
        form.append("status",formData.status);
        form.append("statusBiaya",formData.statusBiaya);
        form.append("statusDokumenPersyaratan",formData.statusDokumenPersyaratan);
        form.append("statusKeharusanApproval",formData.statusKeharusanApproval);
        form.append("statusPengumumanSkp",formData.statusPengumumanSkp);
        
        return axios
        .post(
            API_URL + postWorkshopUrl,
            form, 
            { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } }
        );
    }

    putWorkshopUrl(formData) {
        
        var form = new FormData();
        
        form.append("idKodePelatihan",formData.idKodePelatihan); 
        if (typeof formData.flyer !== 'undefined') {
            form.append('flyer', formData.flyer);
        }
        // if (typeof formData.backgroundSertifikat !== 'undefined') {
        //     form.append('backgroundSertifikat', formData.backgroundSertifikat);
        // }
        form.append("durasi",formData.durasi);
        form.append("tanggalPengumumanSkp",formData.tanggalPengumumanSkp);
        form.append("materi",formData.materi); 
        form.append("linkZoom",formData.linkZoom); 
        form.append("linkKuesioner",formData.linkKuesioner); 
        form.append("statusPenerimaan",formData.statusPenerimaan); 
        form.append("keteranganKuesioner",formData.keteranganKuesioner); 
        form.append("disclaimer",formData.disclaimer);
        form.append("biaya",formData.biaya);
        form.append("biayaAnggotaAp",formData.biayaAnggotaAp);
        form.append("biayaAnggotaNonAp",formData.biayaAnggotaNonAp);
        form.append("biayaUmum",formData.biayaUmum);
        form.append("deskripsiPelatihan",formData.deskripsiPelatihan);
        form.append("idInstruktur",formData.idInstruktur);
        form.append("idKotaKab",formData.idKotaKab);
        form.append("idPenyelenggara",formData.idPenyelenggara);
        form.append("idWorkshopPelatihan",formData.idWorkshopPelatihan);
        form.append("idTandaTangan",formData.idTandaTangan);
        form.append("jumlahKursiAP",formData.jumlahKursiAP);
        form.append("jumlahKursiNonAP",formData.jumlahKursiNonAP);
        form.append("jumlahKursiUmum",formData.jumlahKursiUmum);
        form.append("namaPelatihan",formData.namaPelatihan);
        form.append("namaTempatPelatihan",formData.namaTempatPelatihan);
        form.append("noLaporPPL",formData.noLaporPPL);

        for (let index = 0; index < formData.linkWebinar.length; index++) {
            form.append("linkWebinar["+index+"].idDatLinkWebinar",formData.linkWebinar[index].idDatLinkWebinar = "");
            form.append("linkWebinar["+index+"].linkWebinar",formData.linkWebinar[index].linkWebinar);
            form.append("linkWebinar["+index+"].keterangan",formData.linkWebinar[index].keterangan);
        }
        
        if(formData.linkZoom != 'undefined' || formData.linkZoom != undefined)
        {
            form.append("linkZoom",formData.linkZoom);
        }
        
        form.append("linkMateri",formData.linkMateri);
        for (let index = 0; index < formData.pelatihanMateri.length; index++) {
            if (typeof formData.pelatihanMateri[index].fileMateri !== 'undefined') {
                form.append("pelatihanMateri["+index+"].fileMateri",formData.pelatihanMateri[index].fileMateri);
            }
            form.append("pelatihanMateri["+index+"].namaMateri",formData.pelatihanMateri[index].namaMateri);
            form.append("pelatihanMateri["+index+"].idPelatihanMateri",formData.pelatihanMateri[index].idMateri);
            
        }

        for (let index = 0; index < formData.pelatihanDokumen.length; index++) {
            form.append("pelatihanDokumen["+index+"].idDokumenPelatihan",formData.pelatihanDokumen[index].idDokumenPendukung);
            form.append("pelatihanDokumen["+index+"].idMasterDokumen",formData.pelatihanDokumen[index].idMasterDokumen);
            form.append("pelatihanDokumen["+index+"].statusRequired",formData.pelatihanDokumen[index].statusRequired);
        }

        for (let index = 0; index < formData.pelatihanInstruktur.length; index++) {
            form.append("pelatihanInstruktur["+index+"].idDatInstrukturPelatihan",formData.pelatihanInstruktur[index].idDatInstrukturPelatihan);
            form.append("pelatihanInstruktur["+index+"].idInstrukturPelatihan",formData.pelatihanInstruktur[index].idInstrukturPelatihan);
            form.append("pelatihanInstruktur["+index+"].skpNonTerstruktur",formData.pelatihanInstruktur[index].skpNonTerstruktur);
            form.append("pelatihanInstruktur["+index+"].skpTerstruktur",formData.pelatihanInstruktur[index].skpTerstruktur);

            for (let x = 0; x < formData.pelatihanInstruktur[index].katalogInstruktur.length; x++) {
                form.append("pelatihanInstruktur["+index+"].katalogInstruktur["+x+"].skpTerstrukturKatalog",formData.pelatihanInstruktur[index].katalogInstruktur[x].skpTerstrukturKatalog);
                form.append("pelatihanInstruktur["+index+"].katalogInstruktur["+x+"].skpNonTerstrukturKatalog",formData.pelatihanInstruktur[index].katalogInstruktur[x].skpNonTerstrukturKatalog);
            }
        }

        for (let index = 0; index < formData.pelatihanKatalog.length; index++) {
            form.append("pelatihanKatalog["+index+"].idDatKatalogPelatihan",formData.pelatihanKatalog[index].idDatKatalogPelatihan);
            form.append("pelatihanKatalog["+index+"].idKatalogPelatihan",formData.pelatihanKatalog[index].idKatalogPelatihan);
            form.append("pelatihanKatalog["+index+"].skpNonTerstruktur",formData.pelatihanKatalog[index].skpNonTerstruktur);
            form.append("pelatihanKatalog["+index+"].skpTerstruktur",formData.pelatihanKatalog[index].skpTerstruktur);
        }

        for (let index = 0; index < formData.pelatihanModerator.length; index++) {
            form.append("pelatihanModerator["+index+"].idDatModeratorPelatihan",formData.pelatihanModerator[index].idDatModeratorPelatihan);
            form.append("pelatihanModerator["+index+"].namaModerator",formData.pelatihanModerator[index].namaModerator);
            form.append("pelatihanModerator["+index+"].idModerator",formData.pelatihanModerator[index].idModerator);
            form.append("pelatihanModerator["+index+"].skpNonTerstruktur",formData.pelatihanModerator[index].skpNonTerstruktur);
            form.append("pelatihanModerator["+index+"].skpTerstruktur",formData.pelatihanModerator[index].skpTerstruktur);

            for (let x = 0; x < formData.pelatihanModerator[index].katalogModerator.length; x++) {
                form.append("pelatihanModerator["+index+"].katalogModerator["+x+"].skpTerstrukturKatalog",formData.pelatihanModerator[index].katalogModerator[x].skpTerstrukturKatalog);
                form.append("pelatihanModerator["+index+"].katalogModerator["+x+"].skpNonTerstrukturKatalog",formData.pelatihanModerator[index].katalogModerator[x].skpNonTerstrukturKatalog);
            }
        }

        for (let index = 0; index < formData.jadwalPelatihanRequest.length; index++) {
            form.append("jadwalPelatihanRequest["+index+"].waktuDimulai",formData.jadwalPelatihanRequest[index].waktuDimulai);
            form.append("jadwalPelatihanRequest["+index+"].waktuBerakhir",formData.jadwalPelatihanRequest[index].waktuBerakhir);
            form.append("jadwalPelatihanRequest["+index+"].tanggal",formData.jadwalPelatihanRequest[index].tanggal);
            form.append("jadwalPelatihanRequest["+index+"].idJadwalPelatihan",formData.jadwalPelatihanRequest[index].idJadwalPelatihan);
            
        }

        for (let index = 0; index < formData.pengaturanAssessment.length; index++) {
            form.append("pengaturanAssessment["+index+"].rangeSatu",formData.pengaturanAssessment[index].rangeSatu);
            form.append("pengaturanAssessment["+index+"].rangeDua",formData.pengaturanAssessment[index].rangeDua);
            form.append("pengaturanAssessment["+index+"].assessment",formData.pengaturanAssessment[index].assessment);
            form.append("pengaturanAssessment["+index+"].idPengaturanPelatihanAssessment",formData.pengaturanAssessment[index].idPengaturanPelatihanAssessment);
        }

        if(formData.deletePelatihanMateriRequest.length <= 0) {
            form.append("statusDeletePelatihanMateri",0);
        } else {
            form.append("statusDeletePelatihanMateri",1);
        }
        
        for (let index = 0; index < formData.deletePelatihanMateriRequest.length; index++) {
            form.append("deletePelatihanMateriRequest["+index+"].idPelatihanMateri",formData.deletePelatihanMateriRequest[index].idPelatihanMateri);
        }

        if(formData.deletePelatihanModeratorRequest.length <= 0) {
            form.append("statusDeletePelatihanModerator",0);
        } else {
            form.append("statusDeletePelatihanModerator",1);
        }

        for (let index = 0; index < formData.deletePelatihanModeratorRequest.length; index++) {
            form.append("deletePelatihanModeratorRequest["+index+"].idDatModeratorPelatihan",formData.deletePelatihanModeratorRequest[index].idDatModeratorPelatihan);
        }

        if(formData.deletePelatihanKatalogRequest.length <= 0) {
            form.append("statusDeletePelatihanKatalog",0);
        } else {
            form.append("statusDeletePelatihanKatalog",1);
        }

        for (let index = 0; index < formData.deletePelatihanKatalogRequest.length; index++) {
            form.append("deletePelatihanKatalogRequest["+index+"].idDatKatalogPelatihan",formData.deletePelatihanKatalogRequest[index].idDatKatalogPelatihan);
        }

        if(formData.deletePengaturanAssessmentRequest.length <= 0) {
            form.append("statusDeletePengaturanAssessment",0);
        } else {
            form.append("statusDeletePengaturanAssessment",1);
        }

        for (let index = 0; index < formData.deletePengaturanAssessmentRequest.length; index++) {
            form.append("deletePengaturanAssessmentRequest["+index+"].idPengaturanPelatihanAssessment",formData.deletePengaturanAssessmentRequest[index].idPengaturanPelatihanAssessment);
        }

        if(formData.deletePelatihanDokumenRequest.length <= 0) {
            form.append("statusDeletePelatihanDokumen",0);
        } else {
            form.append("statusDeletePelatihanDokumen",1);
        }

        for (let index = 0; index < formData.deletePelatihanDokumenRequest.length; index++) {
            form.append("deletePelatihanDokumenRequest["+index+"].idDokumenPendukung",formData.deletePelatihanDokumenRequest[index].idDokumenPendukung);
        }

        if(formData.deletePelatihanInstrukturRequest.length <= 0) {
            form.append("statusDeletePelatihanInstruktur",0);
        } else {
            form.append("statusDeletePelatihanInstruktur",1);
        }

        for (let index = 0; index < formData.deletePelatihanInstrukturRequest.length; index++) {
            form.append("deletePelatihanInstrukturRequest["+index+"].idDatInstrukturPelatihan",formData.deletePelatihanInstrukturRequest[index].idDatInstrukturPelatihan);
        }

        if(formData.deleteJadwalPelatihanRequest.length <= 0) {
            form.append("statusDeleteJadwalPelatihan",0);
        } else {
            form.append("statusDeleteJadwalPelatihan",1);
        }

        for (let index = 0; index < formData.deleteJadwalPelatihanRequest.length; index++) {
            form.append("deleteJadwalPelatihanRequest["+index+"].idJadwalPelatihan",formData.deleteJadwalPelatihanRequest[index].idJadwalPelatihan);
        }

        form.append("skpIapiAssesment",formData.skpIapiAssesment);
        form.append("skpIapiNonTerstruktur",formData.skpIapiNonTerstruktur);
        form.append("skpIapiTerstruktur",formData.skpIapiTerstruktur);
        form.append("skpNonIapiNonTerstruktur",formData.skpNonIapiNonTerstruktur);
        form.append("skpNonIapiTerstruktur",formData.skpNonIapiTerstruktur);
        form.append("skpNonIapiAssesment",formData.skpNonIapiAssesment);
        form.append("status",formData.status);
        form.append("statusBiaya",formData.statusBiaya);
        form.append("statusDokumenPersyaratan",formData.statusDokumenPersyaratan);
        form.append("statusKeharusanApproval",formData.statusKeharusanApproval);
        form.append("statusPengumumanSkp",formData.statusPengumumanSkp);
        
        return axios
            .put(
                API_URL + putWorkshopUrl + formData.idWorkshopPelatihan,
                form, 
                { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } }
            );
    }

    putKuesioner(formData) {
        var headers = authHeader();

        return axios
            .put(
                API_URL + putKuesioner + formData.idKuesioner, formData, {
                    headers: authHeader()
                }
            );
    }

    deleteWorkshop(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteWorkshop + formData.id_workshop_pelatihan, {
                    headers: authHeader()
                }
            );
    }

}

export default new WorkshopService();